import { z } from "zod";
import { KycSchema, UserSchema } from "../treezor/index.js";
import updateTreezorAccountCreator from "./updateTreezorAccountCreator.js";

export default {
  params: updateTreezorAccountCreator.params
    .omit({ accountId: true, legalRole: true, isEffectiveBeneficiary: true })
    .extend({ memberInvitationId: z.string() }),
  response: z.object({
    user: UserSchema.extend({ kyc: KycSchema.optional() }),
  }),
};
